import { Microphone } from '@carbon/icons-react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { FormControl, MenuItem, Select } from '@mui/material';

import { useMediaDevicesContext } from '../../providers/media-devices-context';

export const MicrophoneSelector = () => {
  const {
    microphones,
    selectedMicrophone,
    setSelectedMicrophone,
    isRequestingPermissions,
  } = useMediaDevicesContext();

  return (
    <FormControl fullWidth>
      <Select
        value={selectedMicrophone}
        onChange={(e) => setSelectedMicrophone(e.target.value)}
        disabled={isRequestingPermissions}
        startAdornment={<Microphone size={26} />}
        IconComponent={KeyboardArrowDownIcon}
        variant='filled'
        sx={{
          borderRadius: 1,
          '.MuiSelect-select': {
            fontSize: '0.875rem',
          },
          '& fieldset': {
            border: 'none',
          },
        }}
      >
        {microphones.map((mic) => (
          <MenuItem
            key={mic.deviceId}
            value={mic.deviceId}
            sx={{ fontSize: '0.875rem' }}
          >
            {mic.label || `Microphone ${mic.deviceId.substr(0, 5)}`}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
